import { useEffect } from "react";
import toast from "react-hot-toast";
import { Select } from "antd";
import { keyframes } from "@emotion/react";
import noimage from "../assets/images/noimage.png";
const Option = Select;
export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const format = /^[0-9\b]+$/;
const count = 8;
const validPassword = new RegExp("^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$");
const priceDecimal = /^[0-9]*(\.[0-9]{0,2})?$/;
const PATTERN_TTD = new RegExp("^(([А-Яа-яӨҮөү]{2}[0-9]{8})|[0-9]{7})$");

const PRICE_PARSERS = {
  parser: (value) => value.replace(/\$\s?|(,*)/g, ""),
  formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
};

const PHONENO_VALIDATOR = [
  {
    validateTrigger: "onSubmit",
    required: true,
    message: "Утасны дугаар оруулна уу.",
  },
  ({ setFieldsValue }) => ({
    validateTrigger: "onSubmit",
    validator(_, value) {
      if (format.test(value)) {
        if (value.length < count) {
          return Promise.reject(
            new Error("Утасны дугаар 8 оронтой байх ёстой.")
          );
        }
      } else {
        setFieldsValue({ phoneno: value });
        return Promise.reject(new Error("Утасны дугаар дан тоо байх ёстой."));
      }
      return Promise.resolve();
    },
  }),
];
const PASSWORD_VALIDATOR = [{ required: true, message: "Нууц үг оруулна уу." }];

const CREATEPASSWORD_VALIDATOR = [
  {
    validateTrigger: "onSubmit",
    required: true,
    message: "Нууц үг оруулна уу.",
  },
  ({ setFieldsValue }) => ({
    // validateTrigger: "onSubmit",
    validator(_, value) {
      if (!validPassword.test(value) || value.length < count) {
        setFieldsValue({ password: value });
        return Promise.reject(
          new Error("Yсэг, тоо агуулсан 8 буюу түүнээс дээш оронтой байx ёстой")
        );
      }
      return Promise.resolve();
    },
  }),
];

const CONFIRMPASSWORD_VALIDATOR = [
  {
    validateTrigger: "onSubmit",
    required: true,
    message: "Нууц үг оруулна уу.",
  },
  ({ setFieldsValue, getFieldsValue }) => ({
    // validateTrigger: "onSubmit",
    validator(_, value) {
      if (value !== getFieldsValue().password) {
        setFieldsValue({ confirmPassword: value });
        return Promise.reject(new Error("Нууц үг таарахгүй байна"));
      }
      return Promise.resolve();
    },
  }),
];
const EMAIL_VALIDATOR = [
  {
    validateTrigger: "onSubmit",
    required: true,
    type: "email",
    message: "Зөв И-мэйл оруулна уу.",
  },
];

export const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng)
    owntoast("Зөвхөн .PNG эсвэл .JPG зураг оруулах боломжтой.", "warn");

  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) owntoast("Зурагны хэмжээ 2мб -с ихгүй байх ёстой.", "warn");

  return isJpgOrPng && isLt2M;
};

const getEnabledOptions = (props, data, isenable) => {
  let tmp = [];
  if (Array.isArray(data)) {
    data &&
      data.map((item) => {
        if (isenable) tmp.push(item);
        else if (item.isenable !== 0) tmp.push(item);
        return true;
      });
  } else {
    props[`res${data}`] &&
      props[`res${data}`].map((item) => {
        if (isenable) tmp.push(item);
        else if (item.isenable !== 0) tmp.push(item);
        return true;
      });
  }
  return tmp;
};

const GenerateFoodCardDetailValues = (values) => {
  let tmp = [];
  for (let i = 0; i < values.datalength; i++) {
    tmp.push({
      materialid: values[`materialid${i}`],
      unitid: values[`unitid${i}`],
      gross: values[`gross${i}`],
      net: values[`net${i}`],
    });
    delete values[`materialid${i}`];
    delete values[`unitid${i}`];
    delete values[`gross${i}`];
    delete values[`net${i}`];
  }
  values.materials = tmp;
  return values;
};

const renderOptions = (data, label, value, isEnabled, isAll) =>
  data &&
  data.map((item, i) => {
    if (isEnabled) {
      if (item.isenable === 1) {
        return (
          <Option key={i} value={value ? item[value] : item.value}>
            {`${label ? item[label] : item.label}`}
          </Option>
        );
      }
    } else if (isAll) {
      return (
        <Option key={i} value={value ? item[value] : item.value}>
          <div className="flex items-center">
            <img
              src={`${API_URL}${item.imgpos}`}
              alt="zurag"
              onError={({ currentTarget }) => {
                currentTarget.src = noimage;
              }}
              className="w-6 h-6 mr-2"
            />
            {label ? item[label] : item.label}
          </div>
        </Option>
      );
    } else {
      return (
        <Option key={i} value={value ? item[value] : item.value}>
          {`${label ? item[label] : item.label}`}
        </Option>
      );
    }
  });

const groupBy = (items, field) => {
  if (items) {
    return items.reduce((acc, curr) => {
      if (curr[field]) {
        const value = curr[field];
        const currentItems = acc[value];

        return {
          ...acc,
          [value]: currentItems ? [...currentItems, curr] : [curr],
        };
      }
      return acc;
    }, {});
  }
  return [];
};

const keyframesRotate = keyframes`
  50% {
    transform: translateY(-5px);
  }
}`;

const TourConfig = {
  popover: (base) => ({
    ...base,
    "--reactour-accent": "#162654",
    borderRadius: 10,
  }),
  maskArea: (base) => ({ ...base, rx: 10 }),
  maskWrapper: (base) => ({ ...base }),
  badge: (base) => ({ ...base, left: "auto", right: "-0.8125em" }),
  controls: (base) => ({ ...base }),
  close: (base) => ({ ...base, right: "auto", left: 8, top: 8 }),
  dot: (base) => ({
    ...base,
    animationDuration: "1s",
    animationName: keyframesRotate,
    animationIterationCount: "infinite",
    "&:nth-of-type(1)": {
      animationDelay: ".3s",
    },
    "&:nth-of-type(2)": {
      animationDelay: ".6s",
    },
  }),
};
/* const getSaleNum = (order, ressalenum) => {
  if (order && order.salenum) return order.salenum;
  return ressalenum;
}; */

function routeToAddOrEdit({ navigate, params, index, record }) {
  navigate(`/management/${params.id}/${params["*"]}/edit?index=${index}`);
  /* let editRows = JSON.parse(localStorage.getItem("editRows"));
  editRows[params["*"]] = record; */
  localStorage.setItem("editRow", JSON.stringify(record));
}

const owntoast = (msg, type) => {
  toast[type](msg);
};

const isMobile = () => {
  const deviceType = localStorage.getItem("deviceType");
  if (deviceType === "ios" || deviceType === "android") return true;
  return false;
};

const useMobileEvent = (func) => {
  useEffect(() => {
    const device = localStorage.getItem("deviceType");
    if (device === "ios" || device === "android") {
      if (device === "ios") window.addEventListener("message", func);
      else document.addEventListener("message", func);

      return function cleanupListener() {
        if (device === "ios") window.removeEventListener("message", func);
        else document.removeEventListener("message", func);
      };
    }
  }, [func]);
};

const postMessageMobile = (data) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }
};

const API_URL = "https://api.automotive.mn/";
// const API_URL = "http://localhost:1020/";
const SERVICE_URL = "http://localhost:3006/";

export {
  PHONENO_VALIDATOR,
  PASSWORD_VALIDATOR,
  CREATEPASSWORD_VALIDATOR,
  CONFIRMPASSWORD_VALIDATOR,
  EMAIL_VALIDATOR,
  getEnabledOptions,
  GenerateFoodCardDetailValues,
  renderOptions,
  API_URL,
  groupBy,
  /* getSaleNum, */
  priceDecimal,
  PRICE_PARSERS,
  SERVICE_URL,
  routeToAddOrEdit,
  PATTERN_TTD,
  TourConfig,
  owntoast,
  isMobile,
  useMobileEvent,
  postMessageMobile,
};
